export const STATUS_LABELS: Record<string, string> = {
  TIDAK_DIKETAHUI: 'Status Tidak Diketahui',
  VERIFIKASI_BERKAS: 'Verifikasi Berkas',
  DIPANGGIL_WAWANCARA: 'Dipanggil Wawancara',
  KEPUTUSAN_DITERIMA: 'Keputusan Diterima',
  KEPUTUSAN_DITOLAK: 'Keputusan Ditolak',
}
